var E;
(function(o) {
  o.BORDER_BOX = "border-box", o.CONTENT_BOX = "content-box", o.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(E || (E = {}));
export {
  E as ResizeObserverBoxOptions
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@juggle_resize-observer@3.4.0/~/@juggle/resize-observer/lib/ResizeObserverBoxOptions.js
// module id = 833
// module chunks = 41